import React from "react";

const ErrorNotFound = () => {
  return (
    <div className="container text-center">
      <h1 className="mt-5">404</h1>
    </div>
  );
};

export default ErrorNotFound;
